import { useState } from 'react'

export const useGlobalStates = () => {
    
    const [ showForm, setShowForm ] = useState(false)
    const [ stepApplilication, setStepApplilication] = useState(0)
    const [ formOpeningMode, setFormOpeningMode ] = useState('EDITABLE')
    const [ loadingSubmitForm, setLoadingSubmitForm ] = useState(false)

    return {
        showForm, setShowForm,
        stepApplilication, setStepApplilication,
        formOpeningMode, setFormOpeningMode,
        loadingSubmitForm, setLoadingSubmitForm
    }
}